export const SET_ASSETS = 'SET_ASSETS'
export const SET_SELECTED_ASSET = 'SET_SELECTED_ASSET'
export const SET_AUTH = 'SET_AUTH'
